export var TypeActionPackages;
(function (TypeActionPackages) {
    TypeActionPackages["RequestPackageEnoughGoldConfirmed"] = "Package > RequestPackageEnoughGoldConfirmed";
    TypeActionPackages["RequestPackageExpenseConfirmed"] = "Package > RequestPackageExpenseConfirmed";
    TypeActionPackages["ConsumePackages"] = "Package > ConsumePackages";
    TypeActionPackages["ConsumePackage"] = "Package > ConsumePackage";
})(TypeActionPackages || (TypeActionPackages = {}));
export var actionExpenseConfirmed = function (packageId) { return ({
    packageId: packageId,
    type: TypeActionPackages.RequestPackageExpenseConfirmed,
}); };
export var actionConsumePackages = function (packagesInfo) { return ({
    packagesInfo: packagesInfo,
    type: TypeActionPackages.ConsumePackages,
}); };
export var actionConsumePackage = function (packageId, amount) {
    if (amount === void 0) { amount = 1; }
    return ({
        amount: amount,
        packageId: packageId,
        type: TypeActionPackages.ConsumePackage,
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/item-packages/actionPackages.ts
// module id = 180
// module chunks = 3